var English = "Inglés";
var French = "Francés";
var German = "Alemán";
var Italian = "Italiano";
var Japanese = "Japonés";
var Korean = "Coreano";
var Portuguese = "Portugués";
var Russian = "Ruso";
var Spanish = "Español";
var Bahasa = "Indonesio";
var Thai = "Tailandés";
var Vietnamese = "Vietnamita";
var Turkish = "Turco";
var Arabic = "Árabe";
var languagePreference = {
	English: English,
	French: French,
	German: German,
	Italian: Italian,
	Japanese: Japanese,
	Korean: Korean,
	Portuguese: Portuguese,
	Russian: Russian,
	"Chinese-Simplified": "Chino simplificado",
	"Chinese-Traditional": "Chino tradicional",
	Spanish: Spanish,
	Bahasa: Bahasa,
	Thai: Thai,
	Vietnamese: Vietnamese,
	Turkish: Turkish,
	Arabic: Arabic
};

export { Arabic, Bahasa, English, French, German, Italian, Japanese, Korean, Portuguese, Russian, Spanish, Thai, Turkish, Vietnamese, languagePreference as default };
